import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionWrapper } from "../../Styles/style";
import pulsechain from "../../../assets/images/pulsechain.png"
import pulsex from "../../../assets/images/pulsex.png"
import dex from "../../../assets/images/dextool.png"

const Anoutimg = styled.img`
  width: 100%;
  height: auto;
  max-width: 600px;
`;
const GridHEading = styled(Grid)`
place-content: ${(props) => (props.pc ? props.pc : "center")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: center;
`;

const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")}; */
  margin-left: 10px;
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "100PX")};

 }
`
const S2_Aboutus = () => {
  return (
    <div>
      <SectionWrapper bgColor="#0F161B" p="6rem 0 0" p799="0" p599="0" id="about">
        <Container maxWidth="xl">
          <GridHEading container spacing={3}  justifyContent="cneter">

            <Grid item xs={12} md={8} sx={12} data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="200"
              data-aos-duration="500"
              data-aos-offset="0">
                <SectionSubHeading align="center"     p="0px 0"
                m="0">
                  KNOW ABOUT US
                </SectionSubHeading>
              <SectionHeading
                p="0px 0"
                m="0"
                align="center"
                fs="30px"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
              >Richard Heart PARODY
              </SectionHeading>
              <P
                p="0 0 40px 0"
                m="0"
                align="center"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-duration="600"
                data-aos-offset="0"
              >
                Richard Heart Parody, also known as $RHP, is a decentralized token with a total supply of 55 million held entirely in liquidity. With a 1/2 tax system, renounced ownership, and a stealth launch, Richard Heart Parody stands out as a fun and engaging project. We reward the funniest memers every three days, provided that they're holding 1% of the token supply by offering them Pulse token rewards.
</P>
              <div style={{ display: "flex", alignItems: "center",justifyContent:"center" }}>
            
              <a href="https://scan.pulsechain.com/address/0xa0B4a6BBf908D8cd3d3b86Df6C1708C4aAE0c74d"  target="blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1100"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={pulsechain} />
              </a>
              <a href="https://app.pulsex.com/swap?outputCurrency=0xa0B4a6BBf908D8cd3d3b86Df6C1708C4aAE0c74d" target="blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1200"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={pulsex} />
              </a>
              <a href="https://www.dextools.io/app/en/pulse/pair-explorer/0xa0B4a6BBf908D8cd3d3b86Df6C1708C4aAE0c74d" target="blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1200"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={dex} />
              </a>
            </div>
            </Grid>

          </GridHEading>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Aboutus;
